import React, {Component} from "react";
import Strings from "../../../config/Strings";
import {BackButton} from "../../../global/tiger-button/BackButton";
import {TigerButton} from "../../../global/tiger-button/TigerButton";
import {TigerSpinner} from "../../../global/tiger-spinner/TigerSpinner";
import {withToast} from "../../../util/ToastService";
import GlobalConstants from "../../../config/GlobalConstants";
import {GetCustomerSelfService} from "../PremiumService";
import './PremiumSettings.scss';


class PremiumSettings extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            contracts: [],
            selectedContract: {invoices: []},
            selfService: [],
            selectedSelfServiceIndex: 0,
            filter: {
                page: 1,
                per_page: 10,
            },
            lastPage: 1
        };
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.accountId !== this.props.accountId) {
            await this.loadPremiumData();
        }
    }

    async componentDidMount() {
        await this.loadPremiumData();
    }

    async loadPremiumData() {
        this.setState({loading: true});
        if (this.props.accountId != null) {
            let selfServiceResponse = await GetCustomerSelfService();

            if(!selfServiceResponse.error) {
                let selfService = selfServiceResponse.result;

                  this.setState(prevState => ({
                      ...prevState,
                      selectedSelfServiceIndex: 0,
                      selfService: selfService
                  }));
            } else {
                this.props.addToast(Strings.PREMIUM_LOADING_ERROR, {
                    autoDismiss: true,
                    appearance: "error"
                });
            }
        }
        this.setState({loading: false});
    }

    closeView = () => {
        this.props.history.push({
            pathname: "/" + GlobalConstants.APP_PATH + "premium",
            state: this.state.profileLink
        })
    }

    render() {
        return (
            <div className="content-box">
                <BackButton onClick={() => this.closeView()}/>

                <div className="content-header" style={{color: '#00b4eb'}}>{Strings.NAV_PREMIUM}</div>

                {this.state.loading && (
                    <TigerSpinner/>
                )}
                {!this.state.loading &&
                    Array.isArray(this.state.selfService) &&
                    this.state.selfService.length > 0 && (
                        <>
                            {/* Navigation */}
                            <div className="selfservice-nav">
                                {this.state.selfService.map((entry, index) => (
                                <TigerButton key={index} className="btn-ci btn-ci-hover"
                                    variant={index === this.state.selectedSelfServiceIndex
                                    ? "red"
                                    : "light-red"}
                                    type="button"
                                    onClick={() => this.setState({selectedSelfServiceIndex: index})}>
                                        {"Vertrag " + (index + 1)}
                                </TigerButton>
                                ))}
                            </div>


                            {/* Content */}
                            {this.state.selfService[this.state.selectedSelfServiceIndex]?.Url && (
                                <div className="premium-box">
                                    <div className="box-title">Meine Zahlungsdaten</div>
                                    <div className="box-info">
                                        Hier kannst du deine Zahlungsdaten bearbeiten:
                                    </div>
                                    <div className="box-full">
                                        <iframe
                                            src={
                                                this.state.selfService[this.state.selectedSelfServiceIndex]
                                                    .Url
                                            }
                                            width="100%"
                                            height="1200px"
                                            frameBorder={0}
                                            title={`Billwerk self service ${this.state.selectedSelfServiceIndex}`}
                                        />
                                    </div>
                                </div>
                            )}
                        </>
                    )}

            </div>
        )
    }
}

export default withToast(PremiumSettings);